<template>
  <fieldset class="fieldset">
    <legend class="fieldset__label">
      {{ title }}
    </legend>
  
    <div class="form__select">
      <vue-multiselect
        v-bind="$attrs"
        :options="options"
        :track-by="trackBy"
        :label="label"
        :placeholder="placeholder"
        :limit="20"
        :options-limit="2000"
        :loading="loading"
        :internal-search="internalSearch"
        :show-no-results="showNoResults"
        :show-no-options="showNoOptions"
        class="form__vue-multiselect"
        select-label=""
        selected-label=""
        deselect-label=""
        v-on="$listeners"
        @search-change="onSearchChange"
      >
        <span slot="noResult">{{ noResultText }}</span>
        <span slot="noOptions">Список пуст</span>
      </vue-multiselect>
      <div class="form__prompt">{{ promptText }}</div>
      <div v-if="organization">
        <div class="search-filter__dates">
          <label class="search-filter__date">
            <span :class="`search-filter__date-name`">
                с 
                <input type="date" id = "approvedFrom" :value = "approvedFromValue" 
                  @change="handleChange(1)">
                &nbsp;&nbsp;&nbsp;&nbsp; по
                <input type="date" id = "approvedTo" :value = "approvedToValue"
                  @change="handleChange(2)">
              </span>
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import debounce from 'lodash.debounce';
import VueMultiselect from 'vue-multiselect';

export default {
  components: {
    VueMultiselect
  },

  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: () => ''
    },
    optionsLoader: {
      type: Function,
      default: () => null
    },
    trackBy: {
      type: String,
      default: () => 'id'
    },
    label: {
      type: String,
      default: () => 'name'
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    noResultText: {
      type: String,
      default: 'Возможно вы опечатались или такое значение отсутствует.'
    },
    promptText: {
      type: String,
      default: () => ''
    },
    organization: {
      type: Boolean,
      default: () => false
    },
    approvedFromValue: {
      type: String,
      default: () => ''
    },
    approvedToValue: {
      type: String,
      default: () => ''
    }
  },

  data: () => ({
    loadedOptions: null,
    internalLoading: 0,
    searchInputEndWaiting: false
  }),

  computed: {
    options() {
      return this.loadedOptions || this.$attrs.options || [];
    },
    loading() {
      return this.$attrs.loading || !!this.internalLoading;
    },
    internalSearch() {
      return !(this.$attrs.internalSearch === false || this.optionsLoader);
    },
    showNoResults() {
      return !(
        this.searchInputEndWaiting || this.$attrs.showNoResults === false
      );
    },
    showNoOptions() {
      return !(this.optionsLoader || this.$attrs.showNoOptions === false);
    }
  },

  /*async created() {
    if (this.organization) {
      let a = this.approvedFromValue;
      let b = this.approvedToValue;
      debugger;
    }
  },*/

  methods: {
    loadOptions(loader, searchQuery, attrId) {
      this.internalLoading++;
      loader(searchQuery, attrId)
        .then(options => {
          this.loadedOptions = options;
        })
        .catch(error => {
          this.loadedOptions = [];
          console.log(error);
        })
        .finally(() => {
          this.internalLoading--;
        });
    },
    onSearchChange(query, id) {
      if (this.optionsLoader) {
        this.searchInputEndWaiting = true;
        this.debouncedOnSearchChange(this.optionsLoader, query, id);
      }
    },
    debouncedOnSearchChange: debounce(function(loader, query, id) {
      this.searchInputEndWaiting = false;
      this.loadOptions(loader, query, id);
    }, 500),
    handleChange(id) {
      let value;
      if (id === 1) 
        value = approvedFrom.value;
      else if (id === 2) 
        value = approvedTo.value;
      this.$emit('dates-approved-changed', {
        id: id,
        value: value
      })
    }
  }
};
</script>
